module.exports = __webpack_public_path__ + "img/vertical_7_2_0.6032c6e7.png";